import React from 'react';

// Comment / reply bubble icon traced 1:1 from the Figma "Core Task Management"
// comment toolbar (node 20277-45206) so it matches the design exactly — Ant's
// MessageOutlined has different proportions. Uses currentColor + 1em sizing so
// it behaves like any @ant-design/icons icon (inherits text color + font-size,
// adapts to dark mode via CSS variables).
export const CommentBubbleIcon: React.FC = () => (
  <svg width="1em" height="1em" viewBox="0 0 13.3333 13.3333" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1.33333C1.82319 1.33333 1.65362 1.40357 1.5286 1.52859C1.40357 1.65362 1.33333 1.82319 1.33333 2V11.0572L2.86193 9.52858C2.98695 9.40356 3.15652 9.33332 3.33333 9.33332H11.3333C11.5101 9.33332 11.6797 9.26308 11.8047 9.13806C11.9298 9.01303 12 8.84346 12 8.66665V2C12 1.82319 11.9298 1.65362 11.8047 1.52859C11.6797 1.40357 11.5101 1.33333 11.3333 1.33333H2ZM0.585786 0.585786C0.960859 0.210713 1.46957 0 2 0H11.3333C11.8638 0 12.3725 0.210713 12.7475 0.585786C13.1226 0.960858 13.3333 1.46956 13.3333 2V8.66665C13.3333 9.19709 13.1226 9.70579 12.7475 10.0809C12.3725 10.4559 11.8638 10.6667 11.3333 10.6667H3.60948L1.13807 13.1381C0.947406 13.3287 0.660661 13.3858 0.411544 13.2826C0.162428 13.1794 0 12.9363 0 12.6666V2C0 1.46956 0.210714 0.960858 0.585786 0.585786Z"
      fill="currentColor"
    />
  </svg>
);
